import React from 'react'
import { connect } from 'react-redux'
import SchedulerActions from '../../Redux/SchedulerRedux'

class SchedulerName extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      id: props.detail.id,
      form: {
        title: props.detail.title,
        product: props.detail.product,
        date: props.detail.date,
        items: props.detail.items
      }
    }
  }

  _inputChange = (event, field) => {
    event && event.preventDefault()
    let form = { ...this.state.form }
    let value = event.target.value
    form[field] = value
    this.setState({ form })
  }

  _submit = (event) => {
    event && event.preventDefault()
    let data = {
      id: this.state.id,
      form: this.state.form
    }
    setTimeout(() => {
      this.props.putScheduler(data)
      setTimeout(() => {
        this.props.closeModal()
      }, 300)
    }, 300)
  }

  render () {
    return (
      <section className='section' style={{ width: '50vw' }}>
        <header className='title-block'>
          <h1 className='title'> Edit Title</h1>
        </header>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Title</label>
            </div>
            <div className='col-9'>
              <input value={this.state.form.title} onChange={(event) => this._inputChange(event, 'title')} placeholder='Insert Title ...' className='form-control' />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' onClick={() => this.props.closeModal()} className='btn btn-secondary mr-2'><i className='fa fa-times' /> Cancel</button>
              <button type='submit' className='btn btn-primary'><i className='fa fa-save' /> Save</button>
            </div>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProp = (state) => ({
  scheduler: state.scheduler
})

const dispatchToProps = (dispatch) => ({
  putScheduler: (data) => dispatch(SchedulerActions.putSchedulerRequest(data))
})

export default connect(stateToProp, dispatchToProps)(SchedulerName)



// WEBPACK FOOTER //
// ./src/Containers/Scheduler/SchedulerName.js